var _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "#EDEBE9",
    stroke: "#323130"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1.5,
    fill: "#323130",
    stroke: "#323130"
  })));
}

export default SvgCustomSelected;